var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramStankey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608 296C608 282.75 597.25 272 584 272H56C42.75 272 32 282.75 32 296S42.75 320 56 320H178.4L267.406 468.344C271.75 475.578 279.562 480 288 480H584C597.25 480 608 469.25 608 456S597.25 432 584 432H301.594L234.398 320H584C597.25 320 608 309.25 608 296ZM56 240H248C256.438 240 264.25 235.578 268.594 228.344L357.594 80H584C597.25 80 608 69.25 608 56S597.25 32 584 32H344C335.562 32 327.75 36.422 323.406 43.656L234.406 192H56C42.75 192 32 202.75 32 216S42.75 240 56 240Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramStankey);
export default __webpack_public_path__ + "static/media/diagram-stankey.7ef41732867120c74fb80eb52fd15276.svg";
export { ForwardRef as ReactComponent };